import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import toggleOpen from 'local_modules/toggleOpen'

import Collapsible from 'components/ui/Collapsible/Collapsible'


const DropDown = (props) => {
  const {
    children, opener, className, openerClassName, dropListClassName,
    toggleOpen, toggleClose, isToggleActive, activeClassName, dataTestId,
  } = props

  const dropDownClassName = cx(className, {
    [activeClassName]: isToggleActive && activeClassName,
  })

  return (
    <div className={dropDownClassName} data-testid={dataTestId}>
      <div
        className={openerClassName}
        onClick={isToggleActive ? toggleClose : toggleOpen}
      >
        { typeof opener === 'function' ? opener({ isToggleActive }) : opener }
      </div>
      <Collapsible className={dropListClassName} collapsed={!isToggleActive}>
        { typeof children === 'function' ? children({ toggleClose }) : children }
      </Collapsible>
    </div>
  )
}

DropDown.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
  openerClassName: PropTypes.string,
  dropListClassName: PropTypes.string,
  activeClassName: PropTypes.string,
  opener: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.node,
  ]),
  dataTestId: PropTypes.string,
  isToggleActive: PropTypes.bool, // @toggleOpen
  toggleOpen: PropTypes.func, // @toggleOpen
  toggleClose: PropTypes.func, // @toggleOpen
}


export default toggleOpen({ toggleOnWindowClick: true })(DropDown)
